import apiClient from '../apiClient';
import { GET_DOWNLOAD_SCHEDULE_BY_TRANSACTION_ID_URL } from '../apiUrl';

const getDownloadScheduleByTransactionIdApi = Id => {
  return apiClient.get(GET_DOWNLOAD_SCHEDULE_BY_TRANSACTION_ID_URL(Id));
};

export default getDownloadScheduleByTransactionIdApi;
